import { setUserToState } from 'store/actions'
import axios from 'axios'
import { DIAL_CODE, DOCTOR_TYPE } from 'consts'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Col, Row } from 'reactstrap'
import { isValidPhoneNumber, isPostalCode } from 'utils/validations'

function RegisterPersonalInfo({ user, setUser }) {
    const [countries, setCountries] = useState([])
    const [userInfo, setUserInfo] = useState({})
    const [userInfoErrors, setUserInfoErrors] = useState({})
    const [isFormValid, setIsFormValid] = useState(false)
    const [formError, setFormError] = useState('')
    function compareDialCode(a, b) {
        return +a - +b;
    }
    function order(a, b) {
        return a.name < b.name ? -1 : (a.name > b.name ? 1 : 0);
    }
    let sortedDialCode =  [...new Set(DIAL_CODE.map(d => d.dial_code).sort(compareDialCode))]
    const dispatch = useDispatch()

    const formFields = ['First name', 'Last name', 'Nickname (optional)','Prefix','Postal code', 'City', 'Country','Phone number', 'Professional code', 'type']

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_API_URL}/app/country/get-all-countries`)
                setCountries(res.data)
            } catch (error) {
                console.log('error', error)
            }
        }
        fetchData()
    }, [])

    const inputer = (e) => {

        if(e.target.name==='country'){
            const temp = filterCountry(e.target.value)
            // return setUserInfo(prevInfo => ({ ...prevInfo, ['dial']: temp, [e.target.name]: e.target.value}))
            return setUserInfo(prevInfo => ({ ...prevInfo, [e.target.name]: e.target.value}))
            }
        validations(e.target.name, e.target.value)
        setUserInfo(prevInfo => ({ ...prevInfo, [e.target.name]: e.target.value}))
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsFormValid(false)//to disabled the submit button
        let approval_state = 'verified'
        const {registerAttempts} = user.data
        const register_attempts = registerAttempts ? {register_attempts: registerAttempts} : {}
        let doctor = { user_id: user.data.userId, approval_state, ...userInfo, ...register_attempts}
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/app/doctor/create`, { ...doctor }, { headers: { 'Authorization': `Bearer ${user.jwtToken}` } })
            if(res?.data?.message){
                setFormError(res?.data?.message)
                setIsFormValid(true)
                return
            }
            setUser({ ...user, data: { ...user.data, ...res.data } })
            dispatch(setUserToState({ ...user, data: { ...user.data, ...res.data } }))
        } catch (error) {
            console.log('error', error)
            setFormError(error?.response?.data?.message || 'Somthing Went Wrong')
            setIsFormValid(true)
        }
    }

    const checkFormValidation = (isError) => { 
        if(!isError && (Object.values(userInfo).length > formFields.length-1 || (Object.values(userInfo).length === 9 && !Object.keys(userInfo).includes('nickname') ))){
            return true
        }else return false
    }

    useEffect(() => {
        let isErrors = false;
        Object.values(userInfoErrors).forEach(val => { if (val) isErrors = true })
        const isFormValid = checkFormValidation(isErrors)
        setIsFormValid(isFormValid)

    }, [userInfoErrors, userInfo])

    const validations = (key, value) => {
        let error = '';
        if ((!value || !value.length) && key !== 'nickname') {
            error = 'Required'
        } else {
            switch (key) {
                case 'postal_code':
                    !isPostalCode(value) && (error = 'Please enter a valid postal code')
                    break;
                case 'phone_number':
                    if (!isValidPhoneNumber(value)) error = 'Please enter a valid phone number';
                    break;
                case 'professional_code':
                    // what to check???')
                    break;
                default: break
            }
        }
        setUserInfoErrors(prevErrors => ({ ...prevErrors, [key]: error }))
    }

    const countriesInput = (name, field) => {
        return <div key={name} className='form-group row'>
            <Col className='align-items-center d-flex' xs="4"><label className='col-xs-6 m-0' htmlFor={name}>{field}</label></Col>
            <Col xs="8">
                <select onChange={inputer} className='form-control' onBlur={(e) => validations(name,e.target.value)} name={name} value={userInfo?.[name] || 1} id={name}>
                    <option key={1} value={1} disabled>Choose a country</option>
                    {countries.sort(order).map(c => <option key={c.countryCode} value={c.countryCode}>{c.name}</option>)}
                </select>
                {userInfoErrors[name] && <span className='text-red' sm="12">{userInfoErrors[name]}</span>}
            </Col>

        </div>
    }

    const typesInput = (name, field) => {
        return <div key={name} className='form-group row'>
            <Col className='align-items-center d-flex' xs="4"><label className='col-xs-6 m-0' htmlFor={name}>{field}</label></Col>
            <Col xs="8">
                <select onChange={inputer} className='form-control' onBlur={(e) => validations(name,e.target.value)} name={name} value={userInfo?.[name] || 1} id={name}>
                    <option key={1} value={1} disabled>Choose a type</option>
                    {DOCTOR_TYPE.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
                {userInfoErrors[name] && <span className='text-red' sm="12">{userInfoErrors[name]}</span>}
            </Col>

        </div>
    }

    const filterCountry = (value) => {
           const temp =  DIAL_CODE.filter((e)=> e.code === value )
           if (temp){
            return temp[0]?.dial_code
           }  
           else return '+***' 
    }

    const choosePrefix = (name, field) => {
        
        return <div key={name} className='prefix form-group row'>
            <Col className='align-items-center d-flex' xs="4"><label className='col-xs-6 m-0' htmlFor={name}>{field}</label></Col>
            <Col xs="4 p-0">
                 <div onChange={inputer}>
                    <Col> 
                       <input type="radio" value="Dr" name="prefix"/> Dr.
                    </Col>
                    <Col>
                       <input type="radio" value="Prof" name="prefix"/> Prof
                    </Col>
                 </div>
                
            </Col>

        </div>
    }

    const getFields = () => {
        return formFields.map(field => {
            const name = field.replace(' ', '_').toLowerCase().split('_(')[0];
            if (name === 'country') return countriesInput(name, field)
            if (name === 'type') return typesInput(name, field)
            if (name === 'prefix') return choosePrefix(name, field)

            return <div key={name} className='form-group row'>
                <Col className='align-items-center d-flex' xs="4"><label className='col-xs-4 m-0' htmlFor={name}>{field}</label></Col>
                <Col xs="8">
                    <input className='form-control' onInput={inputer} onBlur={(e) => validations(name,e.target.value)} name={name} value={userInfo?.[name]||''} id={name} />
                    {userInfoErrors[name] && <span className='text-red' sm="12">{userInfoErrors[name]}</span>}
                </Col>

            </div>
        })
    }

    return (
        <>
            <Row className='register-info p-5 card m-3 flex-nowrap'>
                <Row className='wrap-info'>
                    <Col sm="8">
                        <form className='personal-info-form ' onSubmit={handleSubmit}>
                            {getFields()}
                            <div className='text-right'><Button disabled={!isFormValid} className="bg-blue text-white">Submit</Button></div>
                            {formError && <span className='text-red' sm="12">{formError}</span>}
                        </form>
                    </Col>                   
                </Row>
            </Row>
        </>
    )
}

export default RegisterPersonalInfo